type NormalizePayoutArgs = {
	// Kept for compatibility with existing call sites so we can inspect stake alongside rewards when needed.
	_stakeBaseUnits: number;
	rawRewardBaseUnits: number;
	didWin: boolean;
};

/**
 * Returns the amount that should be credited back to the local balance when a bet resolves.
 * We intentionally mirror the on-chain payout: zero on losses, the raw reward on wins.
 * Any reconciliation or stake handling is done by the caller; this helper is purely a clamp.
 */
export function calculatePayoutBaseUnits({ rawRewardBaseUnits, didWin }: NormalizePayoutArgs) {
	const safeReward = Number.isFinite(rawRewardBaseUnits) ? Math.max(0, rawRewardBaseUnits) : 0;

	return safeReward;
}
